// extracted by mini-css-extract-plugin
export default {"menu":"HoveringToolbar__menu___ZFH71"};